import { id } from './utilFunctions';

export default (endpoint, transform = id) => {
	return {
		isLoaded: false,
		isLoading: false,
		isError: false,

		data: null,

		loadIf(condition) {
			if (condition && !this.isLoaded) {
				this.load();
			}
		},

		load() {
			console.log(endpoint);
			this.isLoading = true;
			this.data = null;
			this.isLoaded = false;
			fetch(endpoint, { method: 'GET', cache: 'default' }).then(
				(resp) => {
					if (resp.ok) {
						resp.json().then((json) => {
							this.isLoaded = true;
							this.isError = false;
							this.isLoading = false;
							this.data = transform(json);
							console.log(this.data);
						});
					} else {
						this.data = null;
						this.isError = true;
						this.isLoaded = false;
						this.isLoading = false;
					}
				}
			);
		},
	};
};
